export const REPORT_PROFILES = [
  {
    key: "receivable",
    reportType: "receivable",
    selectorLabel: "应收报表",
    subtitle: "销售规模、客户构成、收款开票与原始工作表统一查看",
    fileName: "销售订单付款明细报表.xlsx",
  },
  {
    key: "payable",
    reportType: "payable",
    selectorLabel: "应付报表",
    subtitle: "采购业务、出货核对、业务字典与原始工作表统一查看",
    fileName: "采购订单付款明细报表.xlsx",
  },
];

export const REPORT_PROFILE_BY_KEY = REPORT_PROFILES.reduce((result, profile) => {
  result[profile.key] = profile;
  return result;
}, {});

export function resolveReportAccess(privateRole) {
  const role = Number(privateRole);
  return {
    canViewAll: role === 6,
    profileKeys: role === 6 ? ["receivable", "payable"]
      : role === 4 ? ["receivable"] : role === 5 ? ["payable"] : [],
  };
}

export function canViewReportData(privateRole) {
  return resolveReportAccess(privateRole).profileKeys.length > 0;
}
